import React, { FC, useEffect, useState } from "react";
import { MinusIcon, PlusIcon } from "@heroicons/react/24/solid";

export interface NcInputNumberProps {
  className?: string;
  value?: number;
  defaultValue?: number;
  min?: number;
  max?: number;
  onChange?: (value: number) => void;
  label?: string;
  desc?: string;
}

const NcInputNumber: FC<NcInputNumberProps> = ({
  className = "w-full",
  min = 0,
  max,
  onChange,
  label,
  desc,
  value: propValue,
  defaultValue = 0,
}) => {
  const [value, setValue] = useState(propValue || defaultValue);

  useEffect(() => {
    if (propValue !== undefined) {
      setValue(propValue);
    }
  }, [propValue]);

  const handleClickDecrement = () => {
    if (min >= value) return;
    const newValue = value - 1;
    setValue(newValue);
    onChange && onChange(newValue);
  };

  const handleClickIncrement = () => {
    if (max !== undefined && max <= value) return;
    const newValue = value + 1;
    setValue(newValue);
    onChange && onChange(newValue);
  };

  const renderLabel = () => {
    return (
      <div className="flex flex-col">
        <span className="font-medium text-gray-800 dark:text-gray-200">
          {label}
        </span>
        {desc && (
          <span className="text-xs text-gray-500 dark:text-gray-400 font-light">
            {desc}
          </span>
        )}
      </div>
    );
  };

  return (
    <div
      className={`nc-NcInputNumber flex items-center justify-between space-x-5 ${className}`}
      data-nc-id="NcInputNumber"
    >
      {label && renderLabel()}

      <div
        className={`nc-NcInputNumber flex items-center justify-between w-28`}
      >
        <button
          className="w-8 h-8 rounded-full flex items-center justify-center border border-gray-400 dark:border-gray-500 bg-white dark:bg-gray-900 focus:outline-none hover:border-gray-700 disabled:hover:border-gray-400 dark:disabled:hover:border-gray-500 disabled:opacity-50 disabled:cursor-default"
          type="button"
          onClick={handleClickDecrement}
          disabled={min >= value}
        >
          <MinusIcon className="w-4 h-4" />
        </button>
        <span>{value}</span>
        <button
          className="w-8 h-8 rounded-full flex items-center justify-center border border-gray-400 dark:border-gray-500 bg-white dark:bg-gray-900 focus:outline-none hover:border-gray-700 disabled:hover:border-gray-400 dark:disabled:hover:border-gray-500 disabled:opacity-50 disabled:cursor-default"
          type="button"
          onClick={handleClickIncrement}
          disabled={max !== undefined && max <= value}
        >
          <PlusIcon className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};

export default NcInputNumber;
